import { Pipe, PipeTransform } from '@angular/core';
import { UrlService } from '../services/url/url.service';

@Pipe({
    name: 'imageUrl',
    standalone: false
})
export class ImageUrlPipe implements PipeTransform {
    constructor(private _urlService: UrlService) {}

    transform(value: any): any {
        return this._urlService.relativeImageUrl(value);
    }
}
